// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width:375px){.hollowText[data-v-9f9dc676],.mainText[data-v-9f9dc676]{font-size:var(--font-size-big)}}", ""]);
// Exports
module.exports = exports;
